exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1aHPegpHZ_{box-sizing:border-box;margin-bottom:20px}.McBImsZ9Mg{width:calc(33.3336% - 13.333333333333334px)!important}._39Lugke9ij{width:calc(66.66667% - 10px)!important}._1Z3oAlyuxl{width:calc(50% - 10px)!important}.BtJZv1Vvx-{width:100%!important}._1aHPegpHZ_._1aHPegpHZ_._1aHPegpHZ_{margin-left:0!important}@media screen and (max-width:1100px){.McBImsZ9Mg{width:calc(50% - 10px)!important}._39Lugke9ij{width:100%!important}}@media (max-width:850px){.McBImsZ9Mg{width:100%!important}}", ""]);

// exports
exports.locals = {
	"main": "_1aHPegpHZ_",
	"main--1": "McBImsZ9Mg",
	"main--2": "_39Lugke9ij",
	"main--1-2": "_1Z3oAlyuxl",
	"main--3": "BtJZv1Vvx-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/components/GoalCard/Wrapper.scss
// module id = 651
// module chunks = 5 34 37